import { render, staticRenderFns } from "./gocco-add-2-cart-button.vue?vue&type=template&id=71e0d435&"
import script from "./gocco-add-2-cart-button.vue?vue&type=script&lang=ts&"
export * from "./gocco-add-2-cart-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports